(() => {
  if (window.preLovedFaqBound) return;
  window.preLovedFaqBound = true;
  const setOpen = (item, open) => {
    item.classList.toggle('is-open', open);
    item.querySelector('.pl-faq__question button').setAttribute('aria-expanded', String(open));
    const answer = item.querySelector('.pl-faq__answer');
    answer.setAttribute('aria-hidden', String(!open));
    answer.inert = !open;
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.pl-faq__question button');
    if (!button) return;
    const root = button.closest('.pl-faq');
    if (!root) return;
    const item = button.closest('.pl-faq__item');
    const opening = !item.classList.contains('is-open');
    root.querySelectorAll('.pl-faq__item.is-open').forEach(other => setOpen(other, false));
    if (opening) setOpen(item, true);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('.pl-faq__item');
    if (!item) return;
    item.closest('.pl-faq').querySelectorAll('.pl-faq__item').forEach(other => setOpen(other, other === item));
  });
})();
